import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesWorkflowsSchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-schemes-edit',
	path: '/secure/admin/EditWorkflowScheme.jspa',
};
